export const OPTIONS_MAP = {
  ALL: 0,
  ONGOING: 1,
  UPCOMING: 2
};

export const OPTIONS = [
  { label: 'All', value: OPTIONS_MAP.ALL },
  { label: 'Ongoing', value: OPTIONS_MAP.ONGOING },
  { label: 'Upcoming', value: OPTIONS_MAP.UPCOMING }
];

export const TEST_SERIES_ENROLLED = 'Test Series Enrolled';
export const TEST_SERIES_UNENROLLED = 'Test Series Unenrolled';

export const tabsData = [
  {
    id: 1,
    name: 'About'
  },
  {
    id: 2,
    name: 'Schedule'
  }
];

export const tabsDataWithSyllabus = [...tabsData, { id: 3, name: 'Syllabus' }];

export const enrollmentDetailsTab = { id: 4, name: 'Enrolment details' };

export const CBT_PROGRAMME_TYPE = 14;

export const PROGRAMME_COMPOSITION = {
  ONLINE: 1,
  ONLINE_OFFLINE: 2
};

export const CBT_RESERVE_FLOW = {
  STORE: 1,
  BUNDLE: 2,
  COMBO: 3
};

export const SCROLL_OFFSET_TOP = 140;

export const TAB_INDICES = {
  FIRST_INDEX: 0,
  SECOND_INDEX: 1,
  THIRD_INDEX: 2,
  FOURTH_INDEX: 3
};

export const TEST_SERIES_EVENTS = {
  TEST_SERIES_VIEWED: 'Test Series Viewed',
  TEST_SERIES_BROCHURE_VIEWED: 'Test Series Brochure Viewed',
  TEST_SERIES_SYLLABUS_VIEWED: 'Test Series Syllabus Viewed',
  TEST_SERIES_SCHEDULE_VIEWED: 'Test Series Schedule Viewed',
  TEST_SERIES_SHARED: 'Test Series Shared'
};

export const CBT_TEST_TYPE_ICON_SRC =
  '/test-series-revamp/cbt-test-type-icon.png';
